import React from 'react';
import FieldErrors from '../ErrorComponents/FieldErrors/FieldErrors';
import HelperText from './HelperText';

export default class TextArea extends React.Component {
	constructor(props) {
		super(props);
	}

	render() {
		const {
			icon,
			id,
			name,
			style,
			placeholder,
			rows,
			value,
			onChange,
			helperText,
			fieldErrors
		} = this.props;

		return (
			<div className="TextArea mt-2 mb-4">
				<textarea
					className={`${this.props
						.tailwindStyles} block border border-gray-300 w-full p-2 px-3 h-18 rounded ${icon
						? 'has-icon'
						: ''}`}
					id={id}
					name={name}
					style={style}
					placeholder={placeholder}
					rows={rows}
					value={value || ''}
					onChange={onChange}
				/>
				<div className="p-1">
					{fieldErrors && fieldErrors.hasOwnProperty(name) ? (
						<FieldErrors fieldName={name} fieldErrors={fieldErrors} />
					) : (
						<HelperText>{helperText}</HelperText>
					)}
				</div>
			</div>
		);
	}
}
